import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import app from './modules/app'
import ui from './modules/ui'
import auth from './modules/auth'
import account from './modules/account'
import dashboard from './modules/dashboard'
import ledger from './modules/ledger'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  strict: debug,
  plugins: debug ? [createLogger()] : [],
  modules: {
    app,
    ui,
    auth,
    account,
    dashboard,
    ledger
  }
})
